import { tv } from '@workspace/lib';

export const textSectionVariants = tv({
  slots: {
    section: 'px-md py-lg md:px-full-banner md:py-3xl',
    columns: 'gap-8 lg:gap-12',
    content: '',
  },
});
